
import { MainLayout } from "@/components/layout/MainLayout";
import { Link } from "react-router-dom";

export default function Resources() {
  return (
    <MainLayout>
      <div className="space-y-6">
        <h1 className="text-3xl font-bold">Resources</h1>
        <p className="text-muted-foreground">
          Εκπαιδευτικό υλικό και πόροι για τα μέλη της Web Star. Επιλέξτε μια από τις κατηγορίες στα αριστερά.
        </p>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div className="border rounded-lg p-6 hover:bg-accent transition-colors">
            <h2 className="text-xl font-semibold mb-2">Έγγραφα</h2>
            <p className="text-sm text-muted-foreground mb-4">Εκπαιδευτικά έγγραφα και οδηγοί για διάφορα θέματα.</p>
            <Link to="/resources/documents" className="text-primary hover:underline">Δεί́τε όλα τα έγγραφα →</Link>
          </div>
          <div className="border rounded-lg p-6 hover:bg-accent transition-colors">
            <h2 className="text-xl font-semibold mb-2">Κώδικας</h2>
            <p className="text-sm text-muted-foreground mb-4">Παραδείγματα κώδικα και snippets για ανάπτυξη εφαρμογών.</p>
            <Link to="/resources/code" className="text-primary hover:underline">Δείτε όλο τον κώδικα →</Link>
          </div>
        </div>
      </div>
    </MainLayout>
  );
}
